<div class="card">
  <div class="card-body">
    <div class="acitivity-timeline">
      @for (activityLog of activityLogs; track $index; let i = $index) {
      <div class="acitivity-item d-flex mb-4">
        <div class="flex-shrink-0 avatar-xs">
          <div class="avatar-title bg-light text-muted rounded-circle">
            <i class="ri-user-3-fill"></i>
          </div>
        </div>
        <div class="flex-grow-1 ms-3">
          <h5 class="mb-2"><span
              class="badge bg-soft-primary text-primary align-middle">{{activityLog.activityActionType}}</span></h5>
          <p class="text-muted mb-2">{{
            translate.currentLang === "en"
            ? activityLog?.descriptionEn
            : activityLog?.descriptionAr
            }}</p>
          <small class="mb-0 text-muted">{{activityLog.activityTime}}</small>
        </div>
      </div>
      }
      @if (totalActivityLogPages-1 > page) {
      <div class="mt-3 text-center">
        <a (click)="loadMore()" class="text-muted text-decoration-underline" style="cursor: pointer;">Load More</a>
      </div>
      }
    </div>
  </div><!--end card-body-->
</div><!--end card-->